import { format, isSameYear } from 'date-fns';

export function formatDate(date: Date, today: Date = new Date()): string {
  // Handle invalid dates
  if (!date) {
    return '';
  }

  const sameYear = isSameYear(date, today);

  if (sameYear) {
    // Current year
    return `${format(date, 'MMM d')}`;
  }

  // Different years
  return `${format(date, 'MMM d, yyyy')}`;
}
